export enum EndpointsCheckoutQueryRotes {
  Checkout = '/checkout',
  TokenizeCheckout = '/tokenization/types',
  GateAndDefaultGate = '/v2/init/extra-info',
  EnterAmount = '/init/pay-link',
}

export enum CheckoutQueryKeys {
  Checkout = 'checkout',
  TokenizeCheckout = 'tokenize-checkout',
  GateAndDefaultGate = 'gates',
  EnterAmount = 'enter-amount',
}
